module.exports = __webpack_public_path__ + "img/2.7b61bc13.svg";